import QuestionChoiceForm from '@App/components/QuestionChoiceForm/QuestionChoiceForm';

function Question3Form() {
  return <QuestionChoiceForm questionId="question3" titleKey="text-layer-title" inputPlaceholderKey="text-layer-input-placeholder" resultsTitleKey="text-layer-results-title" nextRoute="../question4" />;
}

export default Question3Form;
